import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function PageFadeIn({ children }) {
    const location = useLocation();
    const [key, setKey] = useState(location.pathname);

    useEffect(() => {
        setKey(location.pathname);
    }, [location.pathname]);

    return (
        <div key={key} className="page-fade-in">
            {children}
        </div>
    );
}

export default PageFadeIn;